import { CaosConfigurationTemplateContentsEnum } from "../enums/CaosConfigurationTemplateContentsEnum";

export class CaosConfigurationTemplate {
    id: number;
    sourceInstallationName: string;
    name: string;
    caosVersion: string;
    configuration: string;
    templateContent: CaosConfigurationTemplateContentsEnum;
    createdBy: string;
    createdAt: Date;
    description: string;

    public parse(obj: any) {
        if (obj.Id) this.id = obj.Id;
        if (obj.SourceInstallationName) this.sourceInstallationName = obj.SourceInstallationName;
        if (obj.Name) this.name = obj.Name;
        if (obj.CaosVersion) this.caosVersion = obj.CaosVersion;
        if (obj.Configuration) this.configuration = obj.Configuration;
        if (obj.TemplateContent) this.templateContent = obj.TemplateContent;
        if (obj.CreatedBy) this.createdBy = obj.CreatedBy;
        if (obj.CreatedAt) this.createdAt = obj.CreatedAt;
        if (obj.Description) this.description = obj.Description;
    }
}
